jQuery.fn.extend({showModal: function() {
  return this.each(function() {
    if (this.tagName === 'DIALOG') {
      this.showModal();
    }
  });
}});

jQuery(function($) {

  $('a').on('click', function(e) {
    let hash = $(this).attr('href');
    $(hash).showModal();
  });

  $('.videogateway').on('click', function(e) {
    $('.gatewaymodal')[0].showModal();
  });

  $('dialog').on('close', function(e) {
    window.location.hash = '';
  });

  if ($('#signup').length) {
    let currentTime = new Date().getTime();

    let ccModal = document.getElementById('signup');
    let modalXprd = 1000 * 60 * 5; // 5 minutes
    let prevModal = localStorage.getItem('modalXptd');
    let notModaled = prevModal === undefined;
    let prevmodalXprd = prevModal !== undefined && currentTime - prevModal > modalXprd;

    $.each(['show', 'hide'], function(i, ev) {
      var el = $.fn[ev];
      $.fn[ev] = function() {
        this.trigger(ev);
        return el.apply(this, arguments);
      };
    });

    $('#signup').on('close', function() {
      localStorage.setItem('modalXptd', currentTime);
    });

    if (notModaled || prevmodalXprd) {
      setTimeout(function() {
        ccModal.showModal();
      }, delaytime);
    }
  }

  $("[placeholder^='interests']").each(function() {
    $(this).replaceWith('<select required id="' + $(this).attr('id') + '" name="' + $(this).attr('name') + '" class="stateselect newselect">' +
    '<option value=""></option>' +
    '<option value="Designing a District Strategic Plan for SEL">Designing a District Strategic Plan for SEL</option>' +
    '<option value="Leading Schoolwide SEL">Leading Schoolwide SEL: Customized Course or Workshop Series</option>' +
    '<option value="SEL Readiness and Engagement Analysis">SEL Readiness and Engagement Analysis</option>' +
    '<option value="Other">Other</option>' +
    '</select>');
  });

  $("[placeholder^='country']").each(function() {
    $(this).replaceWith('<select required id="' + $(this).attr('id') + '" name="' + $(this).attr('name') + '" class="stateselect newselect">' +
    '<option value="US">United States</option>' +
    '<option value="AF">Afghanistan</option>' +
    '<option value="AL">Albania</option>' +
    '<option value="DZ">Algeria</option>' +
    '<option value="AD">Andorra</option>' +
    '<option value="AO">Angola</option>' +
    '<option value="AG">Antigua and Barbuda</option>' +
    '<option value="AR">Argentina</option>' +
    '<option value="AM">Armenia</option>' +
    '<option value="AU">Australia</option>' +
    '<option value="AT">Austria</option>' +
    '<option value="AZ">Azerbaijan</option>' +
    '<option value="BS">Bahamas</option>' +
    '<option value="BH">Bahrain</option>' +
    '<option value="BD">Bangladesh</option>' +
    '<option value="BB">Barbados</option>' +
    '<option value="BY">Belarus</option>' +
    '<option value="BE">Belgium</option>' +
    '<option value="BZ">Belize</option>' +
    '<option value="BJ">Benin</option>' +
    '<option value="BT">Bhutan</option>' +
    '<option value="BO">Bolivia</option>' +
    '<option value="BA">Bosnia and Herzegovina</option>' +
    '<option value="BW">Botswana</option>' +
    '<option value="BR">Brazil</option>' +
    '<option value="BN">Brunei</option>' +
    '<option value="BG">Bulgaria</option>' +
    '<option value="BF">Burkina Faso</option>' +
    '<option value="BI">Burundi</option>' +
    '<option value="CV">Cabo Verde</option>' +
    '<option value="KH">Cambodia</option>' +
    '<option value="CM">Cameroon</option>' +
    '<option value="CA">Canada</option>' +
    '<option value="CF">Central African Republic</option>' +
    '<option value="TD">Chad</option>' +
    '<option value="CL">Chile</option>' +
    '<option value="CN">China</option>' +
    '<option value="CO">Colombia</option>' +
    '<option value="KM">Comoros</option>' +
    '<option value="CG">Congo (Congo-Brazzaville)</option>' +
    '<option value="CD">Congo (Congo-Kinshasa)</option>' +
    '<option value="CR">Costa Rica</option>' +
    '<option value="CI">Cote d\'Ivoire</option>' +
    '<option value="HR">Croatia</option>' +
    '<option value="CU">Cuba</option>' +
    '<option value="CY">Cyprus</option>' +
    '<option value="CZ">Czechia (Czech Republic)</option>' +
    '<option value="DK">Denmark</option>' +
    '<option value="DJ">Djibouti</option>' +
    '<option value="DM">Dominica</option>' +
    '<option value="DO">Dominican Republic</option>' +
    '<option value="EC">Ecuador</option>' +
    '<option value="EG">Egypt</option>' +
    '<option value="SV">El Salvador</option>' +
    '<option value="GQ">Equatorial Guinea</option>' +
    '<option value="ER">Eritrea</option>' +
    '<option value="EE">Estonia</option>' +
    '<option value="ES">Spain</option>' +
    '<option value="ET">Ethiopia</option>' +
    '<option value="FJ">Fiji</option>' +
    '<option value="FI">Finland</option>' +
    '<option value="FR">France</option>' +
    '<option value="GA">Gabon</option>' +
    '<option value="GM">Gambia</option>' +
    '<option value="GE">Georgia</option>' +
    '<option value="DE">Germany</option>' +
    '<option value="GH">Ghana</option>' +
    '<option value="GR">Greece</option>' +
    '<option value="GD">Grenada</option>' +
    '<option value="GT">Guatemala</option>' +
    '<option value="GN">Guinea</option>' +
    '<option value="GW">Guinea-Bissau</option>' +
    '<option value="GY">Guyana</option>' +
    '<option value="HT">Haiti</option>' +
    '<option value="VA">Holy See</option>' +
    '<option value="HN">Honduras</option>' +
    '<option value="HU">Hungary</option>' +
    '<option value="IS">Iceland</option>' +
    '<option value="IN">India</option>' +
    '<option value="ID">Indonesia</option>' +
    '<option value="IR">Iran</option>' +
    '<option value="IQ">Iraq</option>' +
    '<option value="IE">Ireland</option>' +
    '<option value="IL">Israel</option>' +
    '<option value="IT">Italy</option>' +
    '<option value="JM">Jamaica</option>' +
    '<option value="JP">Japan</option>' +
    '<option value="JO">Jordan</option>' +
    '<option value="KZ">Kazakhstan</option>' +
    '<option value="KE">Kenya</option>' +
    '<option value="KI">Kiribati</option>' +
    '<option value="KW">Kuwait</option>' +
    '<option value="KG">Kyrgyzstan</option>' +
    '<option value="LA">Laos</option>' +
    '<option value="LV">Latvia</option>' +
    '<option value="LB">Lebanon</option>' +
    '<option value="LS">Lesotho</option>' +
    '<option value="LR">Liberia</option>' +
    '<option value="LY">Libya</option>' +
    '<option value="LI">Liechtenstein</option>' +
    '<option value="LT">Lithuania</option>' +
    '<option value="LU">Luxembourg</option>' +
    '<option value="MG">Madagascar</option>' +
    '<option value="MW">Malawi</option>' +
    '<option value="MY">Malaysia</option>' +
    '<option value="MV">Maldives</option>' +
    '<option value="ML">Mali</option>' +
    '<option value="MT">Malta</option>' +
    '<option value="MH">Marshall Islands</option>' +
    '<option value="MR">Mauritania</option>' +
    '<option value="MU">Mauritius</option>' +
    '<option value="MX">Mexico</option>' +
    '<option value="FM">Micronesia</option>' +
    '<option value="MD">Moldova</option>' +
    '<option value="MC">Monaco</option>' +
    '<option value="MN">Mongolia</option>' +
    '<option value="ME">Montenegro</option>' +
    '<option value="MA">Morocco</option>' +
    '<option value="MZ">Mozambique</option>' +
    '<option value="MM">Myanmar (formerly Burma)</option>' +
    '<option value="NA">Namibia</option>' +
    '<option value="NR">Nauru</option>' +
    '<option value="NP">Nepal</option>' +
    '<option value="NL">Netherlands</option>' +
    '<option value="NZ">New Zealand</option>' +
    '<option value="NI">Nicaragua</option>' +
    '<option value="NE">Niger</option>' +
    '<option value="NG">Nigeria</option>' +
    '<option value="KP">North Korea</option>' +
    '<option value="MK">North Macedonia</option>' +
    '<option value="NO">Norway</option>' +
    '<option value="OM">Oman</option>' +
    '<option value="PK">Pakistan</option>' +
    '<option value="PW">Palau</option>' +
    '<option value="PS">Palestine State</option>' +
    '<option value="PA">Panama</option>' +
    '<option value="PG">Papua New Guinea</option>' +
    '<option value="PY">Paraguay</option>' +
    '<option value="PE">Peru</option>' +
    '<option value="PH">Philippines</option>' +
    '<option value="PL">Poland</option>' +
    '<option value="PT">Portugal</option>' +
    '<option value="QA">Qatar</option>' +
    '<option value="RO">Romania</option>' +
    '<option value="RU">Russia</option>' +
    '<option value="RW">Rwanda</option>' +
    '<option value="KN">Saint Kitts and Nevis</option>' +
    '<option value="LC">Saint Lucia</option>' +
    '<option value="VC">Saint Vincent and the Grenadines</option>' +
    '<option value="WS">Samoa</option>' +
    '<option value="SM">San Marino</option>' +
    '<option value="ST">Sao Tome and Principe</option>' +
    '<option value="SA">Saudi Arabia</option>' +
    '<option value="SN">Senegal</option>' +
    '<option value="RS">Serbia</option>' +
    '<option value="SC">Seychelles</option>' +
    '<option value="SL">Sierra Leone</option>' +
    '<option value="SG">Singapore</option>' +
    '<option value="SK">Slovakia</option>' +
    '<option value="SI">Slovenia</option>' +
    '<option value="SB">Solomon Islands</option>' +
    '<option value="SO">Somalia</option>' +
    '<option value="ZA">South Africa</option>' +
    '<option value="KR">South Korea</option>' +
    '<option value="SS">South Sudan</option>' +
    '<option value="LK">Sri Lanka</option>' +
    '<option value="SD">Sudan</option>' +
    '<option value="SR">Suriname</option>' +
    '<option value="SE">Sweden</option>' +
    '<option value="CH">Switzerland</option>' +
    '<option value="SY">Syria</option>' +
    '<option value="TW">Taiwan</option>' +
    '<option value="TJ">Tajikistan</option>' +
    '<option value="TZ">Tanzania</option>' +
    '<option value="TH">Thailand</option>' +
    '<option value="TL">Timor-Leste</option>' +
    '<option value="TG">Togo</option>' +
    '<option value="TO">Tonga</option>' +
    '<option value="TT">Trinidad and Tobago</option>' +
    '<option value="TN">Tunisia</option>' +
    '<option value="TR">Turkey</option>' +
    '<option value="TM">Turkmenistan</option>' +
    '<option value="TV">Tuvalu</option>' +
    '<option value="UG">Uganda</option>' +
    '<option value="UA">Ukraine</option>' +
    '<option value="AE">United Arab Emirates</option>' +
    '<option value="GB">United Kingdom</option>' +
    '<option value="UY">Uruguay</option>' +
    '<option value="UZ">Uzbekistan</option>' +
    '<option value="VU">Vanuatu</option>' +
    '<option value="VE">Venezuela</option>' +
    '<option value="VN">Vietnam</option>' +
    '<option value="EH">Western Sahara</option>' +
    '<option value="YE">Yemen</option>' +
    '<option value="ZM">Zambia</option>' +
    '<option value="ZW">Zimbabwe</option>' +
    '</select>');
  });

  $("[placeholder^='state']").each(function() {
    $(this).replaceWith('<select required id="' + $(this).attr('id') + '" name="' + $(this).attr('name') + '" class="stateselect newselect">' +
      '<option value=""></option>' +
      '<option value="AK">Alaska</option>' +
      '<option value="AZ">Arizona</option>' +
      '<option value="AR">Arkansas</option>' +
      '<option value="CA">California</option>' +
      '<option value="CO">Colorado</option>' +
      '<option value="CT">Connecticut</option>' +
      '<option value="DE">Delaware</option>' +
      '<option value="DC">District of Columbia</option>' +
      '<option value="FL">Florida</option>' +
      '<option value="GA">Georgia</option>' +
      '<option value="HI">Hawaii</option>' +
      '<option value="ID">Idaho</option>' +
      '<option value="IL">Illinois</option>' +
      '<option value="IN">Indiana</option>' +
      '<option value="IA">Iowa</option>' +
      '<option value="KS">Kansas</option>' +
      '<option value="KY">Kentucky</option>' +
      '<option value="LA">Louisiana</option>' +
      '<option value="ME">Maine</option>' +
      '<option value="MD">Maryland</option>' +
      '<option value="MA">Massachusetts</option>' +
      '<option value="MI">Michigan</option>' +
      '<option value="MN">Minnesota</option>' +
      '<option value="MS">Mississippi</option>' +
      '<option value="MO">Missouri</option>' +
      '<option value="MT">Montana</option>' +
      '<option value="NE">Nebraska</option>' +
      '<option value="NV">Nevada</option>' +
      '<option value="NH">New Hampshire</option>' +
      '<option value="NJ">New Jersey</option>' +
      '<option value="NM">New Mexico</option>' +
      '<option value="NY">New York</option>' +
      '<option value="NC">North Carolina</option>' +
      '<option value="ND">North Dakota</option>' +
      '<option value="OH">Ohio</option>' +
      '<option value="OK">Oklahoma</option>' +
      '<option value="OR">Oregon</option>' +
      '<option value="PA">Pennsylvania</option>' +
      '<option value="RI">Rhode Island</option>' +
      '<option value="SC">South Carolina</option>' +
      '<option value="SD">South Dakota</option>' +
      '<option value="TN">Tennessee</option>' +
      '<option value="TX">Texas</option>' +
      '<option value="UT">Utah</option>' +
      '<option value="VT">Vermont</option>' +
      '<option value="VA">Virginia</option>' +
      '<option value="WA">Washington</option>' +
      '<option value="WV">West Virginia</option>' +
      '<option value="WI">Wisconsin</option>' +
      '<option value="WY">Wyoming</option>' +
    '</select>');
  });

  const thistitle = $('h1').text();

  if (gated) {
    $("[placeholder^='downloads']").each(function() { $(this).val('This person downloaded “' + thistitle + '”.'); });
  }

  $("[name^='job_title___']").each(function() {
    $(this).replaceWith('<select required id="' + $(this).attr('id') + '" name="' + $(this).attr('name') + '" class="jobtitle newselect">' +
      '<option value=""></option>' +
      '<option value="Assessment/Program Provider">Assessment/Program Provider</option>' +
      '<option value="Business/Corporate Rep">Business/Corporate Rep</option>' +
      '<option value="Counselor/Psychologist">Counselor/Psychologist</option>' +
      '<option value="Funder/Foundation Rep">Funder/Foundation Rep</option>' +
      '<option value="Higher Education">Higher Education</option>' +
      '<option value="Nonprofit Organization">Nonprofit Organization</option>' +
      '<option value="Other">Other</option>' +
      '<option value="Out of School Time Professional">Out of School Time Professional</option>' +
      '<option value="Parent">Parent</option>' +
      '<option value="Researcher">Researcher</option>' +
      '<option value="School District Leader">School District Leader</option>' +
      '<option value="School Leader/Administrator">School Leader/Administrator</option>' +
      '<option value="SEL Coach/Specialist">SEL Coach/Specialist</option>' +
      '<option value="Social Worker">Social Worker</option>' +
      '<option value="State/Federal Policymaker">State/Federal Policymaker</option>' +
      '<option value="Student">Student</option>' +
      '<option value="Teacher">Teacher</option>' +
      '<option value="Other">Other</option>' +
    '</select>');
  });

  $('.newselect').on('change', function() {
    if (this.value === 'Other') {
      let thisid = $(this).attr('id');
      $(this).replaceWith('<input type="text" required id="' + thisid + '" name="' + $(this).attr('name') + '" />');
      $('#' + thisid).focus();
    }
  });

  $('.newselect').focus(function() { $(this).find(' > option:first-child').hide(); });

  $('.ctct-form').on('submit', function() {
    document.getElementById('gateway').close();
  });

  $("[placeholder^='downloads']").parent('p').hide();

});
